import { Input } from "@/components/Input";
import { Controller, useFormContext } from "react-hook-form";
import { P } from "@/components/Typography";

interface IInputState {
  variant?: "error" | undefined;
  message: string;
}

const OnboardingInput = (props: IMatConfigurationInputProperty) => {
  const {
    identifier,
    errorMessage,
    helperText,
    value,
    validation,
    validationHelperText,
    description,
    label,
  } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const determineErrorMessageOrHelperText = (): IInputState => {
    // If we have a browser identified error
    if (!!errors?.[identifier]?.message) {
      return {
        variant: "error",
        message: errors?.[identifier]?.message as string,
      };
    }

    // If the backend said ah now
    if (!!errorMessage) {
      return {
        variant: "error",
        message: errorMessage,
      };
    }

    // default to helper text
    return {
      message: helperText,
    };
  };

  return (
    <Controller
      name={identifier}
      control={control}
      defaultValue={value ?? ""}
      rules={{
        pattern: {
          value: new RegExp(validation ?? "^.*$"),
          message:
            validationHelperText ??
            `Validation failed [Expected format: ${validation}]`,
        },
      }}
      render={({ field }) => (
        <>
          {!!description && <P className="mb-10">{description}</P>}
          <Input
            id={identifier}
            label={label}
            helperText={determineErrorMessageOrHelperText().message}
            variant={determineErrorMessageOrHelperText().variant}
            {...field}
          />
        </>
      )}
    />
  );
};

export default OnboardingInput;
